import React from 'react'
import PropTypes from 'prop-types'
import { SuccessIcon, ErrorIcon, WarningIcon, InfoIcon } from '@ow/icons'
import StyledIcon from '../styled/icon'

const Icon = ({ type, textColor }) => {
  if (type === 'success') {
    return (
      <StyledIcon>
        <SuccessIcon width={20} height={20} fill={textColor} />
      </StyledIcon>
    )
  }
  if (type === 'warning') {
    return (
      <StyledIcon>
        <WarningIcon width={20} height={20} fill={textColor} />
      </StyledIcon>
    )
  }
  if (type === 'error') {
    return (
      <StyledIcon>
        <ErrorIcon width={20} height={20} fill={textColor} />
      </StyledIcon>
    )
  }
  return (
    <StyledIcon>
      <InfoIcon width={20} height={20} fill={textColor} />
    </StyledIcon>
  )
}

Icon.propTypes = {
  type: PropTypes.oneOf(['success', 'error', 'warning', 'info']),
  textColor: PropTypes.string,
}

Icon.defaultProps = {
  type: 'info',
  textColor: '#6576FF',
}
export default Icon
